import { Component, OnDestroy, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SimplebarAngularModule } from "simplebar-angular";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { AppRoutes } from "../../app/routers/appRouters";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-notifications",
  standalone: true,
  imports: [
    CommonModule,
    SimplebarAngularModule,
    NgbDropdownModule,
    RouterModule,
  ],
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent {
  uiState = {
    routers: {
      base: AppRoutes.Notification.base,
    },
  };
}
